import { defineComponent as _defineComponent } from 'vue'
import { Carousel, Slide, Navigation } from "vue3-carousel";
  import { computed, ref } from "vue";
  import "vue3-carousel/dist/carousel.css";
  import BuilderEstimatorHouseLightboxImages from "./BuilderEstimatorHouseLightboxImages.vue";

  interface CarouselProps {
    sliderImages: string[];
    showArrows: boolean;
    isReviewQuote: boolean;
    isBuilderQuoteView?: boolean;
    wrapAround: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseCustomizeSlider',
  props: {
    sliderImages: {},
    showArrows: { type: Boolean, default: true },
    isReviewQuote: { type: Boolean, default: false },
    isBuilderQuoteView: { type: Boolean, default: false },
    wrapAround: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const isImageModalOpen = ref(false);
  const selectedImageUrl = ref("");
  const zoom = ref(1);

  const getSliderNavigation = computed(
    () => props.sliderImages.length > 1 && props.showArrows
  );

  const openImageModal = (imageUrl: string): void => {
    selectedImageUrl.value = imageUrl;
    isImageModalOpen.value = true;
  };

  const closeImageModal = (): void => {
    isImageModalOpen.value = false;
    zoom.value = 1;
  };

  const updateZoom = (value: number): void => {
    const MIN_ZOOM = 1;
    const MAX_ZOOM = 2.6;
    const newZoom = zoom.value + value;

    if (newZoom >= MIN_ZOOM && newZoom <= MAX_ZOOM) {
      zoom.value = newZoom;
    }
  };

const __returned__ = { props, isImageModalOpen, selectedImageUrl, zoom, getSliderNavigation, openImageModal, closeImageModal, updateZoom, get Carousel() { return Carousel }, get Slide() { return Slide }, get Navigation() { return Navigation }, computed, ref, BuilderEstimatorHouseLightboxImages }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})